module.exports = __webpack_public_path__ + "img/ps-dark.9cf9c13c.png";